import log from 'salvo-lite/log'

class TechDrawer {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        document.addEventListener('DOMContentLoaded', () => {
            const sideDraw = document.querySelector('.tech-drawer')
            const closeBtn = document.querySelector('.tech-drawer__close-btn')
            const siteMain = document.querySelector('.site-main')

            if (sideDraw === null || closeBtn === null || siteMain === null) return

            this._elem.addEventListener('click', () => {
                sideDraw.classList.toggle('open')
                siteMain.classList.toggle('tech-drawer-open')
            })

            closeBtn.addEventListener('click', () => {
                sideDraw.classList.toggle('open')
                siteMain.classList.toggle('tech-drawer-open')
            })
        }, false)
    }
}

export default TechDrawer



// WEBPACK FOOTER //
// ./src/resources/scripts/components/TechDrawer.js